import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Container } from '@chakra-ui/react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useQuery } from '@tanstack/react-query';
import { callChannelListApi } from 'lib/api';
import { ResStatus } from 'lib/api/enum';
import { useSetRecoilState } from 'recoil';
import { channelState } from 'lib/atoms/secureState';

function Root() {
  const [loaded, setLoaded] = useState(false);
  const setChannelState = useSetRecoilState(channelState);

  useQuery(['objectionReference'], async () => await callChannelListApi(), {
    cacheTime: 0,
    enabled: true,
    onError: (err) => {
      window.alert('채널데이터 데이터 로딩 실패 ');
    },
    onSuccess: (data) => {
      if (data.status === ResStatus.RES_SUCCESS) {
        setChannelState(data.command.channel_list);
        setLoaded(true);
      } else {
        window.alert('채널데이터 데이터 로딩 실패 ');
      }
    },
  });

  return (
    <Container
      maxW={'768px'}
      minW={'320px'}
      w={'100%'}
      height={'100vh'}
      px={0}
      bg="white">
      {loaded && <Outlet />}
      {process.env.NODE_ENV === 'development' && <ReactQueryDevtools />}
    </Container>
  );
}

export default Root;
